<div class="container-fluid d-flex justify-content-center align-items-center" style="height:100vh; overflow:hidden;">
  <div class=" row text-center d-flex align-items-center no-internet">
    <img src="/assets/images/no-internet.svg" alt="">
    <h1>Whoops!!</h1>
    <p>No internet connection was found.</p>
    <p>Check your connection or try again</p>
  </div>
</div>
